import type { ReactNode } from "react";
import { cn } from "../../ui/index.js";

function overlaySrc(slug: string, preview: boolean): string {
  const q = `slug=${encodeURIComponent(slug)}&fit${preview ? "&preview" : ""}`;
  return `/bundles/livcg/graphics/overlay/index.html?${q}`;
}

/** The real overlay page, scaled into a 16:9 box (`?fit`). PREVIEW renders the
 *  cue (`?preview`), PROGRAM the air. */
export function Monitor({
  slug,
  kind,
  caption,
}: {
  slug: string;
  kind: "preview" | "program";
  caption: ReactNode;
}) {
  const preview = kind === "preview";
  return (
    <div className="flex h-full shrink-0 flex-col gap-1.5">
      <div
        className={cn(
          "relative aspect-video h-[calc(100%-28px)] overflow-hidden rounded-lg border-[3px] bg-[#0b0d12]",
          "bg-[linear-gradient(45deg,#11141b_25%,transparent_25%,transparent_75%,#11141b_75%),linear-gradient(45deg,#11141b_25%,transparent_25%,transparent_75%,#11141b_75%)] bg-[length:24px_24px] bg-[position:0_0,12px_12px]",
          preview ? "border-ready-strong" : "border-live",
        )}
      >
        <iframe
          title={preview ? "PREVIEW" : "PROGRAM"}
          src={overlaySrc(slug, preview)}
          className="pointer-events-none absolute inset-0 h-full w-full border-0"
        />
        <span
          className={cn(
            "absolute left-2 top-2 rounded px-2 py-0.5 text-[11px] font-black tracking-[0.12em]",
            preview ? "bg-ready-strong text-white" : "bg-live text-white",
          )}
        >
          {preview ? "PREVIEW" : "PROGRAM"}
        </span>
      </div>
      <div className="h-[22px] w-0 min-w-full truncate px-1 text-[14px] font-semibold text-ink-soft">
        {caption}
      </div>
    </div>
  );
}
